var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTellStory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "url(#TellStory_svg__a)",
  rx: 22
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__b)",
  d: "M36.341 30.21c-.75-4.403-1.526-8.803-2.326-13.198a2.994 2.994 0 0 0-2.578-2.44c-3.228-.391-6.39.116-9.436 1.515-3.046-1.399-6.208-1.906-9.436-1.515a2.994 2.994 0 0 0-2.578 2.44c-.8 4.395-1.577 8.795-2.327 13.199a.805.805 0 0 0 1.07.892c4.11-1.521 8.417-1.45 12.509.214a2.02 2.02 0 0 0 1.524 0c4.092-1.664 8.398-1.735 12.508-.214a.805.805 0 0 0 1.07-.892Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__c)",
  d: "M9.449 30.855c3.892-1.26 7.936-1.105 11.79.462a2.02 2.02 0 0 0 1.524 0c4.092-1.664 8.398-1.735 12.508-.214a.805.805 0 0 0 1.07-.892c-.749-4.404-1.526-8.804-2.326-13.198a2.994 2.994 0 0 0-2.578-2.44c-3.228-.392-6.39.115-9.436 1.514-3.046-1.399-6.207-1.906-9.436-1.515a2.994 2.994 0 0 0-2.578 2.44c-.716 3.935-1.412 7.873-2.089 11.814l.363.84 1.188 1.189Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__d)",
  d: "M22 31.466c.259 0 .517-.05.762-.149 4.092-1.664 8.398-1.735 12.508-.214a.805.805 0 0 0 1.07-.892c-.749-4.404-1.526-8.803-2.326-13.198a2.994 2.994 0 0 0-2.578-2.44c-3.228-.392-6.39.115-9.436 1.514v15.38Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__e)",
  d: "M35.27 31.103a.805.805 0 0 0 1.07-.892l-.102-.6c-1.969-.955-7.466-2.566-13.154.013H22v1.843c.259 0 .517-.05.762-.15 4.092-1.664 8.398-1.735 12.508-.214Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__f)",
  d: "M36.284 29.877a.804.804 0 0 1-1.013.43c-4.11-1.522-8.416-1.45-12.508.214-.49.199-1.035.199-1.524 0-4.092-1.664-8.398-1.736-12.508-.214a.804.804 0 0 1-1.013-.43l-.058.334a.805.805 0 0 0 1.07.892c4.111-1.521 8.417-1.45 12.509.214a2.02 2.02 0 0 0 1.524 0c4.092-1.664 8.398-1.735 12.508-.214a.805.805 0 0 0 1.07-.892l-.057-.334Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__g)",
  d: "M23.084 28.134h-2.17c-7.223-3.276-13.499-.098-13.267.216.158.215.413.846.558 1.224a.344.344 0 0 0 .415.207c8.22-2.374 12.295.09 12.295.09.107.04.215.083.322.126a2.02 2.02 0 0 0 1.524 0l.323-.127s4.074-2.463 12.294-.09c.17.05.351-.04.415-.206.146-.378.4-1.01.559-1.224.23-.314-6.045-3.492-13.268-.216Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__h)",
  d: "m35.888 29.33-.088.226c-8.459-2.396-12.652.205-12.652.205-.115.046-.228.091-.342.139a2.09 2.09 0 0 1-1.614 0 19.697 19.697 0 0 0-.342-.139s-4.194-2.6-12.653-.205l-.088-.226c8.518-2.439 12.74.18 12.74.18.115.046.229.091.343.139a2.09 2.09 0 0 0 1.614 0c.114-.048.227-.093.342-.139 0 0 4.222-2.619 12.74-.18Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__i)",
  d: "m36.035 28.978-.094.224c-8.552-2.466-12.792.164-12.792.164l-.342.139a2.09 2.09 0 0 1-1.614 0 21.418 21.418 0 0 0-.342-.139s-4.24-2.63-12.793-.164a11.62 11.62 0 0 0-.093-.224c8.615-2.511 12.886.138 12.886.138.114.045.228.09.342.138a2.086 2.086 0 0 0 1.614 0l.342-.138s4.27-2.65 12.886-.138Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__j)",
  d: "m36.194 28.63-.102.22c-8.652-2.54-12.941.121-12.941.121-.115.046-.229.09-.342.139a2.09 2.09 0 0 1-1.614 0 16.522 16.522 0 0 0-.343-.139s-4.289-2.66-12.94-.122l-.103-.218a.166.166 0 0 1 .019-.008c8.708-2.58 13.024.098 13.024.098.115.045.229.09.343.138a2.09 2.09 0 0 0 1.614 0c.113-.047.227-.093.341-.138 0 0 4.317-2.678 13.025-.098a.142.142 0 0 1 .02.008Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__k)",
  d: "M23.084 28.134H22v2.013c.259 0 .517-.05.762-.15l.322-.127s4.075-2.463 12.295-.09c.17.05.351-.04.415-.206.146-.378.4-1.01.559-1.224.23-.314-6.045-3.492-13.269-.216Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__l)",
  d: "M22 28.978c-4.512-2.068-9.306-2.257-13.869-.568a.842.842 0 0 1-1.119-.932c.784-4.603 1.596-9.2 2.432-13.794a3.13 3.13 0 0 1 2.694-2.55c3.374-.41 6.679.121 9.862 1.583v16.261Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__m)",
  d: "M22 28.978c4.512-2.068 9.306-2.257 13.869-.568a.842.842 0 0 0 1.119-.932c-.784-4.603-1.596-9.2-2.432-13.794a3.13 3.13 0 0 0-2.694-2.55c-3.374-.41-6.679.121-9.862 1.583v16.261Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__n)",
  d: "M33.991 17.203c-3.469-1.025-7.06-.835-10.491.571v-.762c3.392-1.393 6.944-1.594 10.377-.608l.114.799Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__o)",
  d: "M34.424 20.261c-3.602-1.176-7.35-1.034-10.924.428v-.763c3.536-1.447 7.244-1.602 10.81-.467l.114.802Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__p)",
  d: "M34.851 23.33c-3.731-1.334-7.635-1.244-11.351.272v-.762c3.679-1.503 7.542-1.607 11.24-.314l.111.804Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__q)",
  d: "m33.55 25.036-.003.765c-3.436-.85-6.807-.61-10.047.715v-.764c3.241-1.324 6.614-1.566 10.05-.716Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__r)",
  d: "M33.555 14.164c-3.333-.881-6.768-.648-10.055.702v-.763c3.244-1.333 6.632-1.579 9.925-.738.025.104.044.21.06.319l.07.48Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__s)",
  d: "M22 12.717v16.262c4.512-2.068 9.306-2.258 13.869-.569a.842.842 0 0 0 1.119-.932 1227.83 1227.83 0 0 0-.68-3.948L24.535 11.758c-.852.255-1.698.574-2.535.959Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__t)",
  d: "M35.869 28.41a.842.842 0 0 0 1.126-.698L22 12.717v16.262c4.512-2.068 9.306-2.257 13.869-.569Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__u)",
  d: "M24.006 11.669a.578.578 0 0 1 .759.55v19.713a.142.142 0 0 1-.235.108l-1.055-.9a.142.142 0 0 0-.185 0l-1.056.9a.142.142 0 0 1-.234-.108V12.836a.58.58 0 0 1 .349-.531c.549-.24 1.101-.452 1.657-.636Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__v)",
  d: "m24.765 15.481-2.754-2.754a.59.59 0 0 0-.011.109v16.142a19.28 19.28 0 0 1 2.765-1.022V15.481Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__w)",
  d: "M21.04 16.732v.797c-3.45-1.517-7.176-1.75-10.864-.662l.114-.771c3.649-1.067 7.333-.844 10.75.636Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__x)",
  d: "M21.04 19.774v.798c-3.574-1.66-7.46-1.928-11.298-.767l.113-.769c3.799-1.142 7.643-.884 11.185.738Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__y)",
  d: "M21.038 22.823v.8c-3.696-1.81-7.737-2.117-11.726-.88l.112-.769c3.948-1.217 7.95-.92 11.614.85Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__z)",
  d: "m19.425 25.117-.082.76c-3.457-1.242-6.967-1.307-10.452-.196.036-.257.072-.513.11-.77 3.476-1.1 6.976-1.033 10.424.206Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#TellStory_svg__A)",
  d: "M21.04 13.706v.793c-3.323-1.38-6.891-1.579-10.427-.566l.037-.249c.028-.184.069-.362.121-.534 3.482-.979 6.993-.784 10.268.556Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__a",
  x1: 5.5,
  x2: 37.5,
  y1: 0,
  y2: 44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8201FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DD01FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__b",
  x1: 22.001,
  x2: 22.001,
  y1: 24.997,
  y2: 33.002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC59B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9447"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__c",
  x1: 22.506,
  x2: 20.725,
  y1: 29.085,
  y2: 21.982,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8A00",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8A00",
  stopOpacity: 0.31
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__d",
  x1: 29.627,
  x2: 20.677,
  y1: 22.955,
  y2: 22.955,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB547",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB547"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__e",
  x1: 28.318,
  x2: 24.063,
  y1: 30.068,
  y2: 30.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB547",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB547"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__f",
  x1: 22.001,
  x2: 22.001,
  y1: 26.883,
  y2: 32.747,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBD13",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBD13"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__g",
  x1: 21.999,
  x2: 21.999,
  y1: 28.823,
  y2: 30.461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2E9DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.228,
  stopColor: "#F0E4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.516,
  stopColor: "#EAD7C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.834,
  stopColor: "#E0C2AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAB49D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__h",
  x1: 21.999,
  x2: 21.999,
  y1: 25.878,
  y2: 31.946,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAB49D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.205,
  stopColor: "#D8B198",
  stopOpacity: 0.204
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.464,
  stopColor: "#D3A788",
  stopOpacity: 0.463
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#CA976E",
  stopOpacity: 0.749
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C08552"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__i",
  x1: 22,
  x2: 22,
  y1: 26.902,
  y2: 31.624,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAB49D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.205,
  stopColor: "#D8B198",
  stopOpacity: 0.204
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.464,
  stopColor: "#D3A788",
  stopOpacity: 0.463
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#CA976E",
  stopOpacity: 0.749
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C08552"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__j",
  x1: 22.002,
  x2: 22.002,
  y1: 25.979,
  y2: 32.718,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAB49D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.205,
  stopColor: "#D8B198",
  stopOpacity: 0.204
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.464,
  stopColor: "#D3A788",
  stopOpacity: 0.463
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#CA976E",
  stopOpacity: 0.749
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C08552"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__k",
  x1: 31.392,
  x2: 21.039,
  y1: 28.374,
  y2: 28.433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAB49D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.205,
  stopColor: "#D8B198",
  stopOpacity: 0.204
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.464,
  stopColor: "#D3A788",
  stopOpacity: 0.463
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#CA976E",
  stopOpacity: 0.749
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C08552"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__l",
  x1: 9.845,
  x2: 24.535,
  y1: 19.989,
  y2: 19.989,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.228,
  stopColor: "#F8F3FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.516,
  stopColor: "#F4ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.834,
  stopColor: "#F1E6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE1FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__m",
  x1: 34.155,
  x2: 19.465,
  y1: 19.989,
  y2: 19.989,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEE1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.266,
  stopColor: "#F5EDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.516,
  stopColor: "#FAF7FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.834,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__n",
  x1: 23.5,
  x2: 33.991,
  y1: 16.782,
  y2: 16.782,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__o",
  x1: 23.5,
  x2: 34.423,
  y1: 19.699,
  y2: 19.699,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__p",
  x1: 23.5,
  x2: 34.851,
  y1: 22.616,
  y2: 22.616,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__q",
  x1: 23.5,
  x2: 33.549,
  y1: 25.527,
  y2: 25.527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__r",
  x1: 23.5,
  x2: 33.555,
  y1: 13.872,
  y2: 13.872,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__s",
  x1: 31.088,
  x2: 3.676,
  y1: 21.644,
  y2: 17.173,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__t",
  x1: 32.192,
  x2: 17.65,
  y1: 24.167,
  y2: 19.431,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7542C9",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.205,
  stopColor: "#7542C9",
  stopOpacity: 0.204
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.464,
  stopColor: "#7542C9",
  stopOpacity: 0.463
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#7542C9",
  stopOpacity: 0.749
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7542C9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__u",
  x1: 22,
  x2: 24.765,
  y1: 21.857,
  y2: 21.857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC6BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.353,
  stopColor: "#B681FA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.564,
  stopColor: "#A168FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.738,
  stopColor: "#8D47FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#7622FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__v",
  x1: 27.657,
  x2: 10.206,
  y1: 24.993,
  y2: 12.209,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__w",
  x1: 10.176,
  x2: 21.04,
  y1: 16.48,
  y2: 16.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__x",
  x1: 9.742,
  x2: 21.04,
  y1: 19.453,
  y2: 19.453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__y",
  x1: 9.312,
  x2: 21.038,
  y1: 22.43,
  y2: 22.43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__z",
  x1: 8.891,
  x2: 19.425,
  y1: 25.005,
  y2: 25.005,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TellStory_svg__A",
  x1: 10.613,
  x2: 21.039,
  y1: 13.517,
  y2: 13.517,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#374373"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B2653"
})))));
export { SvgTellStory as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMGViN2QyYTliZmIwZjkzYWI5OTFkOWQ4YzNkZWY4ODEuc3ZnIjs=";